export default "__VITE_ASSET__YtyZ0GDx__"